<template>

    <v-page-widget title="Recent Pages" :empty="!summaries.length">
        <template #body v-if="!summaries.length">
            <v-notice size="sm" message="No Pages" />
        </template>
        <template #body v-else>
            <v-page-widget-prop v-for="summary in summaries" :key="summary.id"
                :label="summary.url.path"
                :value="summary.last_visited_at | relativeTime">
            </v-page-widget-prop>
        </template>
    </v-page-widget>

</template>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        }
    },

    computed: {

        summaries() {
            return this.customer.page_summaries;
        },

    },

}

</script>
